import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=97b74920&scoped=true"
import script from "./comments.vue?vue&type=script&lang=js"
export * from "./comments.vue?vue&type=script&lang=js"
import style0 from "./comments.vue?vue&type=style&index=0&id=97b74920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b74920",
  null
  
)

export default component.exports